import React from 'react';
import { FadeIn } from './FadeIn';
export function LeadershipStyle() {
  return <section className="relative py-28 md:py-40 bg-navy border-t border-white/5 flex items-center justify-center text-center overflow-hidden" data-id="element-184">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full opacity-20 blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(124,58,237,0.5) 0%, rgba(0,229,255,0.2) 40%, transparent 70%)'
    }} data-id="element-185"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-186">
        <FadeIn data-id="element-187">
          <div className="text-xs uppercase tracking-widest font-medium mb-8" style={{
          background: 'linear-gradient(90deg, #7C3AED, #00E5FF)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }} data-id="element-188">
            Leadership Style
          </div>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-serif leading-tight tracking-tight mb-10" data-id="element-189">
            <span style={{
            background: 'linear-gradient(135deg, #00E5FF, #7C3AED)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }} data-id="element-190">
              Strategic.
            </span>
            <span className="text-softwhite mx-2 md:mx-4" data-id="element-191">·</span>
            <span style={{
            background: 'linear-gradient(135deg, #7C3AED, #E11D74)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }} data-id="element-192">
              Analytical.
            </span>
            <span className="text-softwhite mx-2 md:mx-4" data-id="element-193">·</span>
            <span style={{
            background: 'linear-gradient(135deg, #E11D74, #C8A96A)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }} data-id="element-194">
              Execution-focused.
            </span>
          </h2>
          <p className="text-base md:text-lg text-softwhite/70 font-light max-w-2xl mx-auto leading-relaxed" data-id="element-195">
            A leadership philosophy built on clarity, rigorous governance, and
            the relentless pursuit of operational excellence.
          </p>
        </FadeIn>
      </div>
    </section>;
}